module.exports = __webpack_public_path__ + "static/media/STWire1.66bda747.png";